var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 0.849609C25.6221 0.849609 33 8.0039 33 16.8496C33 25.6953 25.6221 32.8496 16.5 32.8496C7.37786 32.8496 0 25.6953 0 16.8496C0 8.0039 7.37786 0.849609 16.5 0.849609ZM13.4829 25.2839C20.79 25.2839 24.7971 19.4096 24.7971 14.3125V13.8096C25.575 13.261 26.2586 12.5753 26.7771 11.7982C26.07 12.0953 25.2921 12.301 24.4907 12.4153C25.3157 11.9353 25.9521 11.181 26.235 10.2896C25.4571 10.7239 24.6086 11.0439 23.7129 11.2268C22.9821 10.4725 21.945 10.0153 20.8136 10.0153C18.6214 10.0153 16.83 11.7525 16.83 13.8782C16.83 14.1753 16.8536 14.4725 16.9479 14.7468C13.6479 14.5868 10.7014 13.0553 8.745 10.7239C8.415 11.2953 8.20286 11.9582 8.20286 12.6668C8.20286 13.9925 8.91 15.181 9.97071 15.8668C9.31071 15.8668 8.69786 15.6839 8.17929 15.3868V15.4325C8.17929 17.3068 9.54643 18.861 11.3614 19.2268C11.0314 19.3182 10.6779 19.3639 10.3243 19.3639C10.065 19.3639 9.82929 19.341 9.57 19.2953C10.065 20.8268 11.55 21.9468 13.2707 21.9696C11.9036 22.9982 10.1829 23.6153 8.32071 23.6153C7.99071 23.6153 7.68429 23.6153 7.37786 23.5696C9.12214 24.6668 11.22 25.3068 13.4593 25.3068",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7510f5d6143ce4ab8082e06da3c1944b.svg";
export { ForwardRef as ReactComponent };